/** Preserve old shared URLs while emitting one lowercase canonical form. */
export function normalizeLegacyPath(path: string): string {
  return path
    .replace(/^\/?Symbol(?=\/|\?|$)/, "/symbol")
    .replace(/^\/?MonitoringRules(?=\/|\?|$)/, "/monitoring-rules")
    // The Following TAB was removed 2026-09-25 (founder); the same list lives
    // on at /watchlist, so shared /following links still land on it.
    .replace(/^\/?following(?=\/|\?|$)/i, "/watchlist");
}

type NavState = { routes: Array<{ params?: object; state?: NavState } & Record<string, unknown>> } & Record<string, unknown>;

/**
 * A copy of the navigation state holding only params a URL can carry.
 *
 * React Navigation writes every param with `String()`, so an object param
 * (e.g. `entryEvidence`) became `?entryEvidence=[object Object]` — an
 * unshareable link that lost its context on reload. Object params are
 * in-session context, never part of the address: the canonical link is the
 * path plus its primitive params. The live state is not mutated, so the screen
 * still receives the full object.
 */
export function stripNonUrlParams<S extends NavState>(state: S): S {
  return {
    ...state,
    routes: state.routes.map((route) => ({
      ...route,
      ...(route.params
        ? { params: Object.fromEntries(Object.entries(route.params).filter(([, v]) => v === null || typeof v !== "object")) }
        : {}),
      ...(route.state ? { state: stripNonUrlParams(route.state) } : {}),
    })),
  };
}
